import { Card } from "@/types/v2";
import { firestoreToDateTime } from "@/lib/utils";
import { format } from "date-fns";

export interface RoWorkOrderDetailsProps {
  cardData: Card;
}

const formatMaybeDate = (
  value: Card["promisedTime"] | Card["dropOffTime"]
): string => {
  const date = firestoreToDateTime(value);
  return date ? format(date, "MMM d, yyyy h:mm a") : "—";
};

export const RoWorkOrderDetails = ({ cardData }: RoWorkOrderDetailsProps) => {
  // Matches the "Total Sales" computation in CardDetailsView.tsx's
  // Financial Information section: laborSales + partsSales (both stored in
  // cents), converted to dollars. subletSales is intentionally excluded to
  // stay consistent with that existing calculation.
  const estimatedCostCents =
    (cardData.laborSales ?? 0) + (cardData.partsSales ?? 0);

  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2 rounded-lg border border-slate-200 bg-white p-3 text-sm text-foreground shadow-sm">
      <div>
        <h3 className="text-xs font-semibold uppercase text-muted-foreground">
          Estimated Cost
        </h3>
        <p className="font-medium">${(estimatedCostCents / 100).toFixed(2)}</p>
      </div>
      <div>
        <h3 className="text-xs font-semibold uppercase text-muted-foreground">
          Promise Time
        </h3>
        <p className="font-medium">{formatMaybeDate(cardData.promisedTime)}</p>
      </div>
      <div>
        <h3 className="text-xs font-semibold uppercase text-muted-foreground">
          Drop-off
        </h3>
        <p className="font-medium">
          {formatMaybeDate(cardData.dropOffTime ?? null)}
        </p>
      </div>
    </div>
  );
};
